// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2IXz4","amount":"Amount_amount__BeBHA","tip":"Amount_tip__2-gpE","tipHeader":"Amount_tipHeader__2SYPm","tipsWrap":"Amount_tipsWrap__3RtZd"};